import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Form } from 'react-bootstrap';
import { app } from '../state/actions';


const mapStateToProps = state => ({
  colorScheme: state.main.colorScheme,
  notesModalCb: state.app.notesModalCb,
  notesInitValue: state.app.notesInitValue,
});

const mapDispatchToProps = dispatch => ({
  updateNotesModalCb: payload => dispatch(app.updateNotesModalCb(payload)),
  updateNotesInitValue: payload => dispatch(app.updateNotesInitValue(payload)),
});

const JobNotesModal = ({ notesModalCb, colorScheme, updateNotesModalCb, notesInitValue, updateNotesInitValue }) => {
  const [note, setNote] = useState('');
  
  useEffect(() => {
    if(notesInitValue) setNote(notesInitValue);
  }, [notesInitValue]);
  
  return (
    <Modal
      size="sm"
      centered
      show={notesModalCb != null}
      onHide={() => {
        setNote('');
        updateNotesModalCb(null);
        updateNotesInitValue(null);
      }}
      className={`modal-content-${colorScheme.toUpperCase()}`}
    >
      <Modal.Header>
        <Modal.Title>
          Add Note
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Control as="textarea" rows={3} value={note} onChange={event => setNote(event.target.value)}/>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            setNote('');
            updateNotesModalCb(null);
            updateNotesInitValue(null);
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            notesModalCb(note);
            setNote('');
            updateNotesModalCb(null);
            updateNotesInitValue(null);
          }}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(JobNotesModal);